module.exports = __webpack_public_path__ + "static/media/institute-1-min.b206343c.webp";